import AttendanceDetail from "./attendanceDetail";
export default AttendanceDetail;